/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import LocalizationConsumer from '../../../../l10n/localization-context';
import tabs from '../../../../constants/tabs';

const EventOptions = ({
  isEventLinksToDetails,
  onChange,
  activeTab,
  isEventRegistrationFormDisabled
}) =>
{
  if (activeTab !== tabs.EVENTS) return null;

  const radioButton2ClassNames = classnames({
    '-wa-edit-controls__radio-button': true,
    '-wa-edit-controls__radio-button__disabled': isEventRegistrationFormDisabled
  });

  return (
    <div className="-wa-edit-controls__property-container -wa-edit-controls__event-options">
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-event">
        <LocalizationConsumer id="insert-link-dialog.event-link-options.title" />
      </div>
      <div id="idEventLinkToOptionsContainer" className="-wa-edit-controls__property-control">
        <div className="-wa-edit-controls__radio-button-1">
          <input
            id="idRadioLinkToDetails"
            className="-wa-edit-controls__property-input"
            name="isEventLinksToDetails"
            type="radio"
            value="isEventLinksToDetails"
            checked={isEventLinksToDetails === true}
            onChange={e => onChange(e)}
          />
          <label className="-wa-edit-controls__property-label" htmlFor="idRadioLinkToDetails">
            <LocalizationConsumer id="insert-link-dialog.event-link-options.details-page" />
          </label>
        </div>
        <div className={radioButton2ClassNames}>
          <input
            id="idRadioLinkToForm"
            className="-wa-edit-controls__property-input"
            name="isEventLinksToDetails"
            type="radio"
            disabled={isEventRegistrationFormDisabled}
            value="eventLinksToForm"
            checked={isEventLinksToDetails === false}
            onChange={e => onChange(e)}
          />
          <label className="-wa-edit-controls__property-label" htmlFor="idRadioLinkToForm">
            <LocalizationConsumer id="insert-link-dialog.event-link-options.registrations-form" />
          </label>
        </div>
      </div>
    </div>
  );
};

EventOptions.propTypes = {
  activeTab: PropTypes.oneOf(Object.values(tabs)).isRequired,
  isEventLinksToDetails: PropTypes.bool.isRequired,
  isEventRegistrationFormDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default EventOptions;